// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import DemoRentalHistoryDatesCriteria from './demo-rental-history-dates-criteria';

const DemoRentalHistoryDateRangeCriteria = props =>
    <div className='demo-rental-history-date-range-criteria'>
        <DemoRentalHistoryDatesCriteria
            dateRange={props.beginDate}
            label='DEMO_RENTAL_BEGIN_DATE'
            onDateChange={props.onBeginDateChange}
        />
        <DemoRentalHistoryDatesCriteria
            dateRange={props.endDate}
            label='DEMO_RENTAL_END_DATE'
            onDateChange={props.onEndDateChange}
        />
    </div>;

DemoRentalHistoryDateRangeCriteria.displayName = 'DemoRentalHistoryDateRangeCriteria';
DemoRentalHistoryDateRangeCriteria.propTypes = {
    beginDate: PropTypes.instanceOf(DateRange).isRequired,
    endDate: PropTypes.instanceOf(DateRange).isRequired,
    onBeginDateChange: PropTypes.func.isRequired,
    onEndDateChange: PropTypes.func.isRequired
};

export default DemoRentalHistoryDateRangeCriteria;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/components/demo-rental-history-date-range-criteria.js